<template>
  <div class="pourquoi-bio">
    <div class="wrapper" :class="{ 'expanded': visibleSections[0] }">
      <div class="question-title" @click="toggleSection(0)">
        <div class="title">Meilleurs pour la santé.</div>
        <img class="chevron-up" :class="{ 'rotated': !visibleSections[0] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="p" v-show="visibleSections[0]">
        Les produits bio sont cultivés sans pesticides chimiques, ce qui réduit les risques pour la santé.
      </p>
    </div>

    <div class="wrapper" :class="{ 'expanded': visibleSections[1] }">
      <div class="question-title" @click="toggleSection(1)">
        <div class="title">Produits cueillis à maturité.</div>
        <img class="chevron-up" :class="{ 'rotated': !visibleSections[1] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="p" v-show="visibleSections[1]">
        Les produits bio sont souvent cueillis à maturité, ce qui garantit une meilleure qualité nutritionnelle.
      </p>
    </div>

    <div class="wrapper" :class="{ 'expanded': visibleSections[2] }">
      <div class="question-title" @click="toggleSection(2)">
        <div class="title">Garantie de produits naturels.</div>
        <img class="chevron-up" :class="{ 'rotated': !visibleSections[2] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="p" v-show="visibleSections[2]">
        Elle garantit des produits naturels dépourvus de produits chimiques de synthèse.
      </p>
    </div>

    <div class="wrapper" :class="{ 'expanded': visibleSections[3] }">
      <div class="question-title" @click="toggleSection(3)">
        <p class="title">Les produits possèdent plus de goût.</p>
        <img class="chevron-up" :class="{ 'rotated': !visibleSections[3] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="p" v-show="visibleSections[3]">
        Les méthodes de culture bio préservent les saveurs authentiques des produits.
      </p>
    </div>

    <div class="wrapper" :class="{ 'expanded': visibleSections[4] }">
      <div class="question-title" @click="toggleSection(4)">
        <div class="title">Respect de l&#39;environnement.</div>
        <img class="chevron-up" :class="{ 'rotated': !visibleSections[4] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="p" v-show="visibleSections[4]">
        C&#39;est un mode de production qui assure le respect de l&#39;environnement et de la biodiversité
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PourquoiBio",
  data() {
    return {
      visibleSections: [false, false, false, false, false] // All sections hidden by default
    };
  },
  methods: {
    toggleSection(index) {
      this.visibleSections[index] = !this.visibleSections[index];
      // Force reactivity update
      this.$forceUpdate();
    }
  }
};
</script>

<style>
.pourquoi-bio {
  align-items: flex-start;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* flex-wrap: wrap; */
  gap: 12px 12px;
  margin: 0px 8vw;
  align-items: center;
}

.pourquoi-bio .wrapper {
  align-items: flex-start;
  background-color: #edf2d3b7;
  background-color: #eeeeee;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px;
  max-width: -webkit-fill-available;
  transition: all 0.3s ease;
}

.pourquoi-bio .wrapper.expanded {
  min-height: 150px;
}

.pourquoi-bio .question-title {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  width: 100%;
  height: 24px;
  cursor: pointer;
  user-select: none;
}

.pourquoi-bio .question-title:hover {
  opacity: 0.8;
}

.pourquoi-bio .title {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  color: #1d221b;
  display: -webkit-box;
  flex: 1;
  font-family: "Mona-Sans-Bold", Helvetica;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pourquoi-bio .chevron-up {
  height: 24px;
  width: 24px;
  transition: transform 0.3s ease;
}

.pourquoi-bio .chevron-up.rotated {
  transform: rotate(180deg);
}

.pourquoi-bio .p {
  align-self: stretch;
  color: #1d221b;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 18px;
}
@media (max-width: 1200px){
  .pourquoi-bio {
    grid-template-columns: repeat(1, 1fr);
    margin: 0px 6vw;
  }
}

@media (max-width: 768px) {
  .pourquoi-bio {
    margin: 0px 6vw;
    gap: 16px;
  }
  .pourquoi-bio .wrapper {
    padding: 20px;
  }
  .pourquoi-bio .title {
    font-size: 16px;
  }
  .pourquoi-bio .p {
    font-size: 13px;
    line-height: 17px;
  }
}

@media (max-width: 480px) {
  .pourquoi-bio {
    margin: 0px 4vw;
    gap: 12px;
  }
  .pourquoi-bio .wrapper {
    padding: 16px;
  }
  .pourquoi-bio .title {
    font-size: 15px;
  }
  .pourquoi-bio .p {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>